import { Injectable } from '@angular/core';
import { TeethDiagramStore } from '@modules/teeth-diagram/state/teeth-diagram-store';
import { ScanOptionsStore } from '@modules/scan-options/state/scan-options-store';
import { RxIntuitiveTeethDiagramStore } from '@modules/rx-intuitive-teeth-diagram/state/rx-intuitive-teeth-diagram-store';
import { ShellStore } from '@shared/store/shell/shell-store';

/**
 * Centralized service for resetting RX-related stores.
 * Use when procedure or send-to changes require clearing dependent state.
 */
@Injectable()
export class RxIntuitiveStoresResetService {
	constructor(
		private readonly teethDiagramStore: TeethDiagramStore,
		private readonly scanOptionsStore: ScanOptionsStore,
		private readonly shellStore: ShellStore,
		private readonly intuitiveDiagramStore: RxIntuitiveTeethDiagramStore
	) {}

	/**
	 * Resets teeth diagram, scan options, sets procedure-changed flag, and deselects bridge.
	 */
	resetDependingStores(): void {
		this.teethDiagramStore.resetTeeth();
		this.scanOptionsStore.reset();
		this.shellStore.updateProcedureChangedFlag(true);
		this.intuitiveDiagramStore.reset();
	}
}
